import { usePlatform } from "@platform/PlatformContext";

export const useUserFullname = () => {
  const { user } = usePlatform();
  return [user?.first_name, user?.last_name].filter(Boolean).join(" ");
};

export default useUserFullname;
